
let companyTypeOptions = [
    <option value="1">Dentistry</option>,
    <option value="2">Lab</option>,
    <option value="3">Other</option>
]

export default companyTypeOptions;
